import {
  SET_SOCKET_MESSAGE,
  CLEAR_SOCKET_MESSAGE,
  SET_SOCKET_MESSAGE_ERROR,
  SET_EXCHANGE_MESSAGE,
  CLEAR_EXCHANGE_MESSAGES
} from '../actions/socketMessage';

const initialState = {
  currentMessage: null,
  messageHistory: [],
  error: null,
  lastUpdated: null,
  mcxSpecialMarginInfo: null,
  // Exchange-specific message stores - only store current message for each exchange
  exchangeMessages: {
    MCX: {
      currentMessage: null,
      messageHistory: [], // Keep empty - only current message is stored
      lastUpdated: null
    },
    NFO: {
      currentMessage: null,
      messageHistory: [], // Keep empty - only current message is stored
      lastUpdated: null
    },
    CDS: {
      currentMessage: null,
      messageHistory: [], // Keep empty - only current message is stored
      lastUpdated: null
    },
    DCSX: {
      currentMessage: null,
      messageHistory: [], // Keep empty - only current message is stored
      lastUpdated: null
    },
    NSE: {
      currentMessage: null,
      messageHistory: [],
      lastUpdated: null
    },
    ALL: {
      currentMessage: null,
      messageHistory: [],
      lastUpdated: null
    }
  }
};

const socketMessageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SOCKET_MESSAGE:
      const newMessage = action.payload;

      // Extract MCX special margin information if available
      let mcxSpecialMarginInfo = state.mcxSpecialMarginInfo;
      if (newMessage?.exchange === 'MCX' && newMessage?.bodMessage?.includes('special/additional margin calculation')) {
        mcxSpecialMarginInfo = {
          sessionTime: newMessage.currentSession?.[0]?.sessionTime,
          marketStatus: newMessage.marketStatus,
          marginMessage: newMessage.bodMessage,
          contracts: newMessage.bodMessage.match(/\[(.*?)\]/)?.[1]?.split(' ') || [],
          receivedAt: newMessage.receivedAt
        };
      }

      return {
        ...state,
        currentMessage: newMessage,
        messageHistory: [
          newMessage,
          ...state.messageHistory.slice(0, 9) // Keep last 10 messages
        ],
        error: null,
        lastUpdated: newMessage.receivedAt || new Date().toISOString(),
        mcxSpecialMarginInfo
      };

    case CLEAR_SOCKET_MESSAGE:
      return {
        ...state,
        currentMessage: null,
        error: null
      };

    case SET_SOCKET_MESSAGE_ERROR:
      return {
        ...state,
        error: action.payload,
        lastUpdated: new Date().toISOString()
      };

    case SET_EXCHANGE_MESSAGE:
      const { exchange, messageData } = action.payload;

      // Ensure the exchange exists in our store
      if (!state.exchangeMessages[exchange]) {
        return state; // Skip if exchange is not supported
      }

      return {
        ...state,
        exchangeMessages: {
          ...state.exchangeMessages,
          [exchange]: {
            currentMessage: messageData, // Only store as current message
            messageHistory: [], // Keep history empty as requested
            lastUpdated: messageData.receivedAt || new Date().toISOString()
          }
        }
      };

    case CLEAR_EXCHANGE_MESSAGES:
      const exchangeToClear = action.payload;

      if (exchangeToClear) {
        // Clear specific exchange - keep history empty
        return {
          ...state,
          exchangeMessages: {
            ...state.exchangeMessages,
            [exchangeToClear]: {
              currentMessage: null,
              messageHistory: [], // Keep empty - only current message is stored
              lastUpdated: null
            }
          }
        };
      } else {
        // Clear all exchanges - keep history empty
        return {
          ...state,
          exchangeMessages: {
            MCX: {
              currentMessage: null,
              messageHistory: [], // Keep empty - only current message is stored
              lastUpdated: null
            },
            NFO: {
              currentMessage: null,
              messageHistory: [], // Keep empty - only current message is stored
              lastUpdated: null
            },
            CDS: {
              currentMessage: null,
              messageHistory: [], // Keep empty - only current message is stored
              lastUpdated: null
            },
            NSE: {
              currentMessage: null,
              messageHistory: [],
              lastUpdated: null
            },
            ALL: {
              currentMessage: null,
              messageHistory: [],
              lastUpdated: null
            }
          }
        };
      }

    default:
      return state;
  }
};

export default socketMessageReducer; 